import { render, staticRenderFns } from "./DialogManager.vue?vue&type=template&id=a8e73b5c&scoped=true&"
import script from "./DialogManager.vue?vue&type=script&lang=ts&"
export * from "./DialogManager.vue?vue&type=script&lang=ts&"
import style0 from "./DialogManager.vue?vue&type=style&index=0&id=a8e73b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e73b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
